module.exports = __webpack_public_path__ + "img/brand-02.271af565.png";